module.exports = __webpack_public_path__ + "img/1520915189.5405c2c2.jpg";